import React, { FC } from 'react';
import { DivCheckboxBlockList } from './styles';
import { ClearButton } from '../ClearButton';
import { FilterLayout } from '../FilterLayout';
import { TCheckBoxListValues, TCurrentFilter } from '../../../../commonTypes/filters';
import { Checkboxes } from '../../components/Checkboxes';
import { FnPerfectScrollbarVariants } from '../../../../components/elements/FnPerfectScrollbar/constants';
import FnPerfectScrollbar from '../../../../components/elements/FnPerfectScrollbar/index';
import { DivWrapper } from '../TextBox/styles';

interface Props {
  name: string;
  value: TCheckBoxListValues;
  currentFilterItems: TCurrentFilter[];
  onSetFilter: (data: TCurrentFilter) => void;
  onClearFilter: (data: string) => void;
  showClearBtn?: boolean;
}

export const CheckboxList: FC<Props> = ({
  name,
  value,
  currentFilterItems,
  onSetFilter,
  onClearFilter,
  showClearBtn = true
}: Props) => {
  const handleClearFilter = () => {
    onClearFilter(name);
  };

  return (
    <>
      <FilterLayout>
        <DivCheckboxBlockList>
          <FnPerfectScrollbar component="div" styled variant={FnPerfectScrollbarVariants.Secondary}>
            <DivWrapper>
              <Checkboxes
                data={value}
                name={name}
                isCheckboxList={true}
                currentFilterItems={currentFilterItems}
                onSetFilter={onSetFilter}
                onClearFilter={onClearFilter}
              />
            </DivWrapper>
          </FnPerfectScrollbar>
        </DivCheckboxBlockList>
      </FilterLayout>
      {showClearBtn && <ClearButton onClear={handleClearFilter} />}
    </>
  );
};
